/* Shipping Protection — pure cart logic. No DOM, no network. Loaded before shipping-protection.js. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.ShippingProtectionCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var ATTR = 'Shipping Protection';
  var DISCLOSURE_ATTR = '_Shipping Protection Disclosure';

  function isProtectionItem(item, cfg) {
    var id = String(item.product_id);
    return id === String(cfg.productId) || (cfg.legacyProductIds || []).map(String).indexOf(id) !== -1;
  }

  function isCurrentProtection(item, cfg) {
    return String(item.product_id) === String(cfg.productId);
  }

  function isExcluded(item, cfg) {
    var type = String(item.product_type || '').toLowerCase();
    return !!type && (cfg.excludedProductTypes || []).some(function (t) { return String(t).toLowerCase() === type; });
  }

  function shippableSubtotalCents(cart, cfg, rate) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (isProtectionItem(item, cfg) || item.requires_shipping === false || isExcluded(item, cfg)) return;
      total += item.final_line_price;
    });
    return Math.round(total / (rate || 1));
  }

  function tierFor(cents, tiers) {
    var found = null;
    (tiers || []).forEach(function (t) { if (cents >= t.minCents) found = t; });
    return found;
  }

  function disclosure(cfg, nowIso) {
    return 'v' + cfg.copyVersion + ' ' + nowIso;
  }

  // "Required for orders {amount}+" → "Required for orders $500+" (shop-currency threshold, USD formatting).
  function fillAmount(text, cents) {
    var d = cents / 100;
    var money = '$' + d.toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return String(text || '').split('{amount}').join(money);
  }

  // Black or white check mark, whichever reads better on the accent color.
  function contrastColor(hex) {
    var m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
    if (!m) return '#ffffff';
    var lum = (0.299 * parseInt(m[1], 16) + 0.587 * parseInt(m[2], 16) + 0.114 * parseInt(m[3], 16)) / 255;
    return lum > 0.6 ? '#111111' : '#ffffff';
  }

  function plan(cart, cfg, opts) {
    var attrs = cart.attributes || {};
    var sub = shippableSubtotalCents(cart, cfg, opts.rate);
    var countries = cfg.countries || [];
    var inCountry = countries.length === 0 || !opts.country || countries.indexOf(opts.country) !== -1;
    var usable = cfg.enabled && inCountry && cfg.tiers && cfg.tiers.length > 0 && sub > 0 && sub >= (cfg.hideBelowCents || 0);
    var tier = usable ? tierFor(sub, cfg.tiers) : null;
    var required = cfg.requiredEnabled !== false && sub >= cfg.requiredThresholdCents;
    var state = !tier ? 'hidden' : required ? 'required' : 'optional';

    var choice = attrs[ATTR] === 'Added' ? true : attrs[ATTR] === 'Declined' ? false : null;
    var checked = state === 'required' || (state === 'optional' && (choice === null ? !!cfg.defaultChecked : choice));
    var want = checked ? String(tier.variantId) : null;

    var updates = {};
    var kept = false;
    var protectionQty = 0;
    cart.items.forEach(function (item) {
      if (!isProtectionItem(item, cfg)) return;
      if (want && !kept && isCurrentProtection(item, cfg) && String(item.variant_id) === want) {
        kept = true;
        protectionQty = 1;
        if (item.quantity !== 1) updates[item.key] = 1;
      } else {
        updates[item.key] = 0;
      }
    });
    if (want && !kept) { updates[want] = 1; protectionQty = 1; }

    var attributes = {};
    if (state === 'required' && attrs[ATTR] !== 'Required') {
      attributes[ATTR] = 'Required';
      attributes[DISCLOSURE_ATTR] = disclosure(cfg, opts.now);
    } else if (state === 'optional' && (choice === null)) {
      attributes[ATTR] = checked ? 'Added' : 'Declined';
      attributes[DISCLOSURE_ATTR] = disclosure(cfg, opts.now);
    } else if (state === 'hidden' && (attrs[ATTR] || attrs[DISCLOSURE_ATTR])) {
      // Never offered on this cart: drop any earlier choice so the order doesn't carry it.
      attributes[ATTR] = '';
      attributes[DISCLOSURE_ATTR] = '';
    }

    var changed = Object.keys(updates).length > 0 || Object.keys(attributes).length > 0;
    return { state: state, tier: tier, checked: checked, updates: updates, attributes: attributes, changed: changed, protectionQty: protectionQty };
  }

  return {
    ATTR: ATTR, DISCLOSURE_ATTR: DISCLOSURE_ATTR,
    isProtectionItem: isProtectionItem, shippableSubtotalCents: shippableSubtotalCents,
    tierFor: tierFor, disclosure: disclosure, plan: plan, contrastColor: contrastColor, fillAmount: fillAmount,
  };
});
